module.exports = __webpack_public_path__ + "static/media/store-sample.b7986e4a.jpg";